import { useCallback, useEffect, useState } from "react";
import { fetchTemplatePreviewAsync } from "@features/report/template/services/reportTemplateSvc";
import {
    ReportTemplatePreview,
    ReportTemplatePreviewResult,
    TemplatePreviewQuery,
} from "../types/reportTemplatePreview";

function normalizePreviewPayload(
    raw: ReportTemplatePreview | ReportTemplatePreview[] | null | undefined
): ReportTemplatePreview | null {
    if (!raw) return null;
    if (Array.isArray(raw)) return raw[0] ?? null;
    return raw;
}

export function useReportPreviewTemplates(params: TemplatePreviewQuery): ReportTemplatePreviewResult {
    const [data, setData] = useState<ReportTemplatePreview | null>(null);

    const [loading, setLoading] = useState(true);

    const { departmentId, reportTemplateId, nationId, districtId, churchId } = params;

    const reload = useCallback(async () => {
        if (!departmentId || !reportTemplateId) {
            setData(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const scope =
                nationId != null || districtId != null || churchId != null
                    ? { nationId, districtId, churchId }
                    : undefined;
            const response = await fetchTemplatePreviewAsync(departmentId, reportTemplateId, scope);
            if (response) {
                const d = response.getData();
                setData(normalizePreviewPayload(d));
            }
        } finally {
            setLoading(false);
        }
    }, [departmentId, reportTemplateId, nationId, districtId, churchId]);

    useEffect(() => {
        void reload();
    }, [reload]);

    return { data, loading, reload };
}
